var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27054_371239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_27054_371239)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27054_371239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3991 11.988C12.3991 12.2084 12.2204 12.3871 12 12.3871C11.7795 12.3871 11.6008 12.2084 11.6008 11.988C11.6008 11.7676 11.7795 11.5889 12 11.5889C12.2204 11.5889 12.3991 11.7676 12.3991 11.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7892 12.0209C14.7892 12.2414 14.6105 12.4201 14.3901 12.4201C14.1696 12.4201 13.991 12.2414 13.991 12.0209C13.991 11.8005 14.1696 11.6218 14.3901 11.6218C14.6105 11.6218 14.7892 11.8005 14.7892 12.0209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.009 11.9791C10.009 12.1995 9.83032 12.3782 9.60989 12.3782C9.38946 12.3782 9.21075 12.1995 9.21075 11.9791C9.21075 11.7587 9.38946 11.58 9.60989 11.58C9.83032 11.58 10.009 11.7587 10.009 11.9791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.134 8.89584C17.0733 8.79588 16.935 8.77904 16.8524 8.8617C16.7937 8.92038 16.7829 9.01143 16.8259 9.08236C17.3411 9.93103 17.6227 10.9036 17.6368 11.9195C17.6578 13.4311 17.0687 14.8941 16.0045 15.9678C14.9376 17.0444 13.5141 17.6375 11.9994 17.6373C10.5037 17.6371 9.07141 17.0437 8.01371 15.9861C6.94441 14.9168 6.35761 13.4937 6.36261 11.9807C6.36753 10.4904 6.95991 9.06746 8.01371 8.01356C9.07851 6.94886 10.4941 6.36246 11.9999 6.36246C13.0451 6.36246 14.0467 6.64519 14.9178 7.17406C14.9887 7.21707 15.0796 7.20609 15.1383 7.1475C15.2211 7.06469 15.2039 6.92645 15.1038 6.86566C14.1816 6.30578 13.1219 6.00531 12.0159 6.00246C10.4318 5.99836 8.90389 6.62441 7.77879 7.73956C6.63339 8.87486 6.00239 10.3894 6.00269 12.001C6.003 13.5921 6.63425 15.1156 7.75929 16.2406C8.89699 17.3783 10.4112 18.0026 12.021 17.9971C13.6063 17.9917 15.1199 17.3615 16.2409 16.2406C17.3736 15.1078 17.9974 13.6018 17.9974 11.9999C17.9974 10.888 17.6967 9.82236 17.134 8.89566L17.134 8.89584Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27054_371239",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#331801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F5D32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27054_371239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27054_371239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.284fa8d829a474e5cdd639c4faee2feb.svg";
export { ForwardRef as ReactComponent };